import { render, staticRenderFns } from "./Term.vue?vue&type=template&id=0c99ffe5"
import script from "./Term.vue?vue&type=script&lang=js"
export * from "./Term.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports